import { t } from "i18next"
import * as z from "zod"
import { stringRequired, textAreaDefaultMaxLength } from "@/models/common"

export const generalAttestationSchema = z.object({
  to: stringRequired.max(200, { message: t("common.fieldErrorList.characterLimit") }),
  subject: stringRequired.max(200, { message: t("common.fieldErrorList.characterLimit") }),
  message: stringRequired.max(textAreaDefaultMaxLength, { message: t("common.fieldErrorList.characterLimit") }),
})

export type GeneralAttestationForm = z.infer<typeof generalAttestationSchema>
